import { Injectable } from '@angular/core';
import { FeatureFlagsRulesService, Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { SaleDocumentAdjustmentRepositoryBase } from '@skylab-shared/business';
import { ClientRepository } from '../client/client.repo';
import { ProductRepository } from '../product/product.repo';
export { SaleDocumentAdjustmentRepositoryBase };

@Injectable({providedIn: 'root'})
@Wrapper(SaleDocumentAdjustmentRepositoryBase)
export class SaleDocumentAdjustmentRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
        productRepository: ProductRepository,
        clientRepository: ClientRepository,
        queryBus: QueryBus,
        featureFlagsRulesService: FeatureFlagsRulesService
    ) { }
}
